/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import {
    createSlug,
    getErrorDetailsFn,
    getInputFieldProps,
    parseOnlyNumericValue,
    removeSpecialCharAndNumFn,
    safeToString,
    sliceText,
} from "../../../../utils/common";
import useAPIHandler from "../../../../hook/use-api-handler";
import { leaveTypeSchema } from "./leave-validation";
import { logger, safeString } from "../../../../utils/logger";
import { LEAVE_INITIAL_STATE } from "./leave-constant";


const useLeaveService = ({ openSnackbar }) => {
    const [leave, setLeave] = useState(LEAVE_INITIAL_STATE);
    const [leaveListinfo, setLeaveListinfo] = useState([]);
    const [errors, setErrors] = useState({});

    const [pagination, setPagination] = useState({
        page: 1,
        pageSize: 2,
        total: 0,
        totalPages: 1,
    });

    const { fetchData } = useAPIHandler();


    async function leaveLists(page = 1, pageSize = 10) {
        try {
            const URL = `/admin/leave-type?page=${page}&pageSize=${pageSize}`;
            const METHOD = "GET";

            try {
                const result = await fetchData({
                    url: URL,
                    method: METHOD,
                });

                setLeaveListinfo(result?.data?.leaveType);
                setPagination({
                    page: result?.data?.pagination?.page || 1,
                    pageSize: result?.data?.pagination?.pageSize || 2,
                    total: result?.data?.pagination?.total || 0,
                    totalPages: result?.data?.pagination?.totalPages || 1,
                });
            } catch (err) {
                console.error("Error fetching organizations:", err);
            }
        } catch (error) {
            logger.log(error)
        }
    }

    const handleChange = (e, name) => {
        let value = e;
        if (e && e.target) {
            value = e.target.value;
            name = e.target.name
        }

        if (name === "leave_type_name") {
            value = sliceText(removeSpecialCharAndNumFn(safeToString(value), 150))
        }
        

        setLeave((prevInfo) => ({
            ...prevInfo,
            [name]: value
        }));

        const fieldSchema = leaveTypeSchema.extract(name);
        const { error } = fieldSchema.validate(value);
        if (!error) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                [name]: error ? error.details[0].message : undefined,
            }));
        }

    }

    function handleBlurFn(e, name) {
        let value = e;

        if (e && e.target) {
            value = e.target.value;
        }

        const fieldSchema = leaveTypeSchema.extract(name);
        const { error } = fieldSchema.validate(value);

        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: error ? error.details[0].message : undefined,
        }));
    }

    const handleSubmit = async () => {
        try {
            const { leave_type_name } = leave;
            
            const { error } = leaveTypeSchema.validate({ leave_type_name }, { abortEarly: false });
    
            const validationErrors = error
                ? error.details.reduce((acc, err) => {
                      acc[err.path.join(".")] = err.message;
                      return acc;
                  }, {})
                : {};
    
            setErrors(validationErrors);
            if (Object.keys(validationErrors).length > 0) {
                return false;
            }
    
            const response = await fetchData({
                url: "/admin/leave-type/create",
                method: "POST",
                data: { leave_type_name },
            });
    
            if (response.status === "success") {
                setLeave(LEAVE_INITIAL_STATE);
                openSnackbar({
                    message: "Leave Type Created Successfully",
                    color: "success",
                });
                leaveLists();
                return true;
            } else {
                throw new Error(response.message || "An error occurred");
            }
        } catch (error) {
            handleAPIError(error);
            return false;
        }
    };
    

    const handleUpdate = async (id) => {
        const { leave_type_name } = leave;
    
        const { error } = leaveTypeSchema.validate(
            { leave_type_name },
            { abortEarly: false }
        );
    
        const validationErrors = error
            ? error.details.reduce((acc, err) => {
                  acc[err.path.join(".")] = err.message;
                  return acc;
              }, {})
            : {};
    
        setErrors(validationErrors);
    
        if (Object.keys(validationErrors).length > 0) {
            return false;
        }
    
        try {
            const response = await fetchData({
                url: `/admin/leave-type/modify/${id}`,
                method: "POST",
                data: { leave_type_name },
            });
    
            if (response.status === "success") {
                setLeave(LEAVE_INITIAL_STATE);
                openSnackbar({
                    message: "Leave Type Updated Successfully",
                    color: "success",
                });
                leaveLists();
                return true;
            }
        } catch (error) {
            handleAPIError(error);
            // openSnackbar({
            //     message: error.message || "Failed to create leave type. Please try again.",
            //     color: "error",
            // });
            return false;
        }
    };
    

    //   function hanldeAddAnotherFn() {
    //     setaddAnother((prev) => !prev);
    //   }

    const handleAPIError = (error) => {
        if (error?.type === "JoiValidationError") {
            const errorsAll = {};
            error?.errors?.reduce((acc, curr) => {
                const { field, message } = curr;

                errorsAll[field] = message;

                return acc;
            });
            openSnackbar({
                message:
                    Object.keys(errorsAll).length > 0
                        ? "Validation Error!"
                        : "Something went wrong!",
                color: "danger",
            });
            setErrors(errorsAll);
        }
        else if (error?.type === "GeneralError") {
            const backendMessage = typeof error.message === "string"
                ? error.message
                : "An unexpected error occurred.";

            openSnackbar({
                message: backendMessage,
                color: "danger",
            });
        }
        logger.log(error)
    };
    

    useEffect(() => {
        leaveLists()
    }, []);


    return {
        leaveListinfo,
        leave,
        handleChange,
        handleBlurFn,
        errors,
        setLeave,
        setErrors,
        handleSubmit,
        handleUpdate,
        leaveLists,
        pagination
    };
};

export default useLeaveService;